/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageOutputBody
 */
export interface MessageOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof MessageOutputBody
     */
    readonly $schema?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageOutputBody
     */
    message: string;
}

/**
 * Check if a given object implements the MessageOutputBody interface.
 */
export function instanceOfMessageOutputBody(value: object): value is MessageOutputBody {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function MessageOutputBodyFromJSON(json: any): MessageOutputBody {
    return MessageOutputBodyFromJSONTyped(json, false);
}

export function MessageOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'message': json['Message'],
    };
}

export function MessageOutputBodyToJSON(json: any): MessageOutputBody {
    return MessageOutputBodyToJSONTyped(json, false);
}

export function MessageOutputBodyToJSONTyped(value?: Omit<MessageOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Message': value['message'],
    };
}

